import { Message } from 'element-ui'
import { createKeys } from 'public/utils/decrypt-max-plugin'
import { getModelValue } from 'public/utils'
// import { openKuasheng } from 'public/utils/open-ks'
import { textOverflow } from 'public/components/kye-canvas-table/utils'
import { cellPaddingWidth, tableTextColor, btnColor } from 'public/components/kye-canvas-table/config'
import copyIcon from '../assets/copy.svg'
// import ksIcon from '../assets/ks.svg'

const COPY_ICON = new Image()
COPY_ICON.src = copyIcon

// const KS_ICON = new Image()
// KS_ICON.src = ksIcon

const ICON_SIZE = 12

const COPY = 'copy'

// const KS = 'ks'

const CUSTOM = 'custom'

const TIP_TEXT_MAP = {
  [COPY]: '复制'
}

const STYLE = {
  padding: '8px 12px',
  color: '#333333',
  marginBottom: 0,
  minWidth: 'auto'
}

// 复制内容到剪贴板
function copyTextToClipBoard (text, msg = '已复制到剪贴板') {
  const element = document.createElement('textarea')

  element.value = text

  element.setAttribute('readonly', '')

  element.style.position = 'absolute'
  element.style.left = '-9999px'

  document.body.appendChild(element)
  element.select()
  element.setSelectionRange(0, element.value.length)


  try {
    document.execCommand('copy')
    Message.success(msg)
  } catch (e) {
    console.error(e)
    throw new Error(e)
  }

  element.remove()
}

// 获取元素宽高
function getElementSize (str) {
  const { minWidth, padding } = STYLE
  let div = document.createElement('div')
  div.className = 'el-popover el-popper'
  div.style.minWidth = minWidth
  div.style.padding = padding
  div.style.visibility = 'hidden'
  div.style.position = 'absolute'
  div.style.top = '-9999px'
  div.setAttribute('x-placement', 'top')
  div.innerHTML = str

  let arrowDiv = document.createElement('div')
  arrowDiv.className = 'popper__arrow'
  div.appendChild(arrowDiv)
  document.body.appendChild(div)

  let rect = div.getBoundingClientRect()
  let width = rect.width
  let height = rect.height

  let arrowRect = arrowDiv.getBoundingClientRect()
  let arrowWidth = arrowRect.width
  let arrowHeight = arrowRect.height
  document.body.removeChild(div)
  return {
    width,
    height,
    arrowWidth,
    arrowHeight
  }
}

function setStyle (element, style) {
  for (const rule in style) {
    element.style[rule] = `${style[rule]}`
  }
}

function createPopper (vm) {
  vm.$nextTick(() => {
    const tableDom = vm.$el
    // 气泡盒子
    let poperDom = tableDom.querySelector('#table-cell-popper')
    if (!poperDom) {
      poperDom = document.createElement('div')
      poperDom.className = 'el-popover el-popper'
      poperDom.style.display = 'none'
      poperDom.setAttribute('id', 'table-cell-popper')
      poperDom.setAttribute('x-placement', 'top')

      poperDom.innerHTML = '<span></span>'

      // 箭头
      const arrowDom = document.createElement('div')
      arrowDom.setAttribute('x-arrow', '')
      arrowDom.className = 'popper__arrow'
      poperDom.appendChild(arrowDom)
      tableDom.appendChild(poperDom)
    }
  })
}

function updatePopper (vm, e) {
  const { x, startX, startY, row, col, flatRow, canvasTable } = e
  const showCellTip = canTriggerEvents(vm, { x, col, row, canvasTable })
  const tableDom = vm.$el
  let poperDom = tableDom.querySelector('#table-cell-popper')
  const arrowDom = poperDom.querySelector('.popper__arrow')
  if (showCellTip) {
    // 自定义悬浮文本
    const drawColumnOptions = vm._drawColumnOptions
    let iconTip = drawColumnOptions[col.key] && drawColumnOptions[col.key].iconTip
    if (typeof iconTip === 'function') {
      iconTip = iconTip(row, flatRow)
    }
    iconTip = iconTip || TIP_TEXT_MAP[col.widgetType] || ''

    if (!iconTip) {
      return
    }

    const iconW = ICON_SIZE + cellPaddingWidth * 2
    const { width, height, arrowWidth } = getElementSize(iconTip)
    const style = {
      ...STYLE,
      display: 'inline-block',
      top: (startY - height) + 'px',
      left: (startX + iconW / 2 - width / 2) + 'px'
    }
    const arrowStyle = {
      left: (width - arrowWidth) / 2 + 'px'
    }
    poperDom.querySelector('span').innerText = iconTip
    setStyle(arrowDom, arrowStyle)
    setStyle(poperDom, style)
  } else {
    poperDom.style.display = 'none'
  }
}

function closePopper (vm) {
  const tableDom = vm.$el
  let poperDom = tableDom.querySelector('#table-cell-popper')
  if (poperDom) {
    poperDom.style.display = 'none'
  }
}

// 判断监控字段
function isMask (row, key) {
  return getModelValue(row, key + 'Mask') !== undefined
}

// 判断虚拟号字段
function isVirtual (row, key) {
  return getModelValue(row, key + 'Virtual') !== undefined
}

function isDecrypt (flatRow, key) {
  // 字段如果被批量解密，mask判断有误，需判断字段是否已经批量解密
  const { keyDecryptOrder } = createKeys(key)
  const hasBatchDecrypt = flatRow.hasOwnProperty(keyDecryptOrder)
  const mask = !hasBatchDecrypt && isMask(flatRow, key)
  return mask || isVirtual(flatRow, key)
}

// 自定义icon内容大小
function getIconWidth (vm, row, options) {
  const { canvasTable, col } = options
  const { ctx, textCtx } = canvasTable
  const drawColumnOptions = vm._drawColumnOptions
  const hasIconWidth = drawColumnOptions[col.key] && drawColumnOptions[col.key].hasOwnProperty('iconWidth')
  let iconWidth = drawColumnOptions[col.key] && drawColumnOptions[col.key].iconWidth
  if (typeof iconWidth === 'function') {
    iconWidth = iconWidth(row, { ctx, textCtx })
  }
  // 有设置宽度，不设置默认宽度
  return (hasIconWidth ? iconWidth : ICON_SIZE) || 0
}

// 点击区域判断
function canTriggerEvents (vm, options) {
  const { x, col, row, canvasTable } = options
  const { scroll } = canvasTable
  // 单元格最左侧 x 位置
  const lx = col.fixed === 'left' ? col.x : (col.x - scroll.disx)
  // 点击范围
  const cx = lx + getIconWidth(vm, row, { col, canvasTable }) + cellPaddingWidth * 2
  return x > lx && cx > x
}

// 绘制复制icon
function paintCopyCell (vm, options) {
  const { ctx, x, y, canvasTable } = options
  const { ratio } = canvasTable
  const iconWidth = ICON_SIZE * ratio
  // 绘制icon
  ctx.drawImage(COPY_ICON, x, y - iconWidth / 2, iconWidth, iconWidth)
}

// 绘制跨声icon
// function painKsCell (vm, options) {
//   const { ctx, x, y, canvasTable } = options
//   const { ratio } = canvasTable
//   const iconWidth = ICON_SIZE * ratio
//   // 绘制icon
//   ctx.drawImage(KS_ICON, x, y - iconWidth / 2, iconWidth, iconWidth)
// }

// 绘制自定义icon区域
function paintCustomCell (vm, options) {
  const drawColumnOptions = vm._drawColumnOptions
  const { ctx, x, y, col, canvasTable, row } = options
  const { ratio, textCtx } = canvasTable
  let iconRender = drawColumnOptions[col.key] && drawColumnOptions[col.key].iconRender
  if (!iconRender) {
    return
  }
  if (typeof iconRender === 'function') {
    iconRender = iconRender(row, { ...options, ctx, textCtx, x, y })
  } else {
    const iconWidth = getIconWidth(vm, row, { col, canvasTable }) * ratio
    ctx.drawImage(iconRender, x, y - iconWidth / 2, iconWidth, iconWidth)
  }
}

function paintWidgetCell (vm, options) {
  const { ctx, x, y, col, text, row, canvasTable } = options
  const { ratio, textCtx } = canvasTable
  if (!col.widgetType) {
    return
  }
  // 复制
  col.widgetType === COPY && paintCopyCell(vm, options)
  // 复制
  // col.widgetType === KS && painKsCell(vm, options)
  // 自定义icon区域
  col.widgetType === CUSTOM && paintCustomCell(vm, options)

  // 绘制文字,暂时只考虑居左默认场景
  let iconWidth = getIconWidth(vm, row, { col, canvasTable }) * ratio
  iconWidth = Number(iconWidth) === 0 ? 0 : (iconWidth + cellPaddingWidth)
  const textObj = textOverflow(textCtx, text, col.width - iconWidth, ratio)
  let textColor = tableTextColor
  if (isMask(row, col.key) || isVirtual(row, col.key)) {
    textColor = btnColor
  }
  ctx.fillStyle = textColor
  ctx.fillText(textObj.text, x + iconWidth, y)
}

function setDrawColumnOptions (vm) {
  if (vm.column && vm.column.length) {
    const drawColumnOptions = vm.drawColumnOptions
    // 防止多次执行被覆盖
    if (Object.keys(vm._drawColumnOptions).length) {
      return
    }
    vm._drawColumnOptions = Object.assign({}, drawColumnOptions)
    vm.column.forEach(col => {
      const canDrawColumn = !drawColumnOptions[col.key] || (drawColumnOptions[col.key] && typeof drawColumnOptions[col.key] === 'object')
      if (!col.widgetType || !canDrawColumn) {
        return
      }
      drawColumnOptions[col.key] = (options) => paintWidgetCell(vm, options)
    })
  }
}

/**
 * 表格支持复制等内部提供的相关功能：
 * 1、考虑通用性（支持传icon、方法、icon大小等）
 * 2、考虑点击区域范围
 * 3、考虑不污染canvas-table组件代码，使用内部抛出事件、api
 * 4、可支持 { iconRender, iconWidth, iconFunc, copyText, position, iconTip, func }
 */
function cellClick (vm, e) {
  const drawColumnOptions = vm._drawColumnOptions
  const { x, column, rowData, flatRow, value, canvasTable } = e
  let copyText = value
  const iconClick = canTriggerEvents(vm, { x, col: column, row: rowData, canvasTable })
  if (!column.widgetType) {
    return
  }
  if (iconClick) {
    const iconFunc = drawColumnOptions[column.key] && drawColumnOptions[column.key].iconFunc
    if (column.widgetType === COPY) {
      // 自定义复制文本内容
      let copyTextFunc = drawColumnOptions[column.key] && drawColumnOptions[column.key].copyText
      // 自定义复制iconFunc点击事件, 自行处理
      if (typeof iconFunc === 'function' && iconFunc(rowData, flatRow) === true) {
        return
      }
      if (copyTextFunc) {
        copyText = typeof copyTextFunc === 'function' ? copyTextFunc(rowData, flatRow) : copyTextFunc
      }
      if (!copyText) {
        Message.warning(`无复制内容`)
        return
      }
      copyTextToClipBoard(copyText)
    }
    // if (column.widgetType === KS) {
    //   openKuasheng(getModelValue(rowData, column.widgetKey || 'employeeNumber'))
    // }
    if (typeof iconFunc === 'function') {
      iconFunc(rowData, flatRow)
    }
  } else {
    // 解密事件
    const cb = vm.handleDecrypt
    // 内容区域自定义点击事件
    let func = drawColumnOptions[column.key] && drawColumnOptions[column.key].func
    if (func && typeof func === 'function') {
      func(rowData)
      // func(rowData, index, { flatRow, cb })
    } else {
      // 解密场景
      if (isDecrypt(flatRow, column.key)) {
        cb(rowData, flatRow, column)
      }
    }
  }
}

function cellMove (vm, e) {
  updatePopper(vm, e)
}

function tableLeave (vm, e) {
  closePopper(vm)
}

function createEvents (vm) {
  vm.$on('any-cell-click', e => cellClick(vm, e))
  vm.$on('any-cell-move', e => cellMove(vm, e))
  vm.$on('table-leave', e => tableLeave(vm, e))
}

function createWatch (vm) {
  vm.$watch('column', () => setDrawColumnOptions(vm))
}

function createData (vm) {
  // canva-table组件实际 drawColumnOptions 对应的 key 字段对应的 value 是个函数，在table-list需做处理，扩展参数
  vm._drawColumnOptions = {}
}

function createMethods (vm) {
  setDrawColumnOptions(vm)
}

function install (vm) {
  createData(vm)
  createMethods(vm)
  createEvents(vm)
  createWatch(vm)
  createPopper(vm)
}

export default install





// WEBPACK FOOTER //
// ./src/public/components/query-table/module/table-cell-plugin.js